import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const Filters = styled(Stack)(
  ({theme}) => css`
    width: 291px;
    overflow-y: hidden;
    scrollbar-gutter: stable;

    &:hover,
    &:focus {
      overflow-y: auto;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.contentTertiary};
      border-radius: 5px;
    }
  `
);
